var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"why-module"},[_c('div',{staticClass:"why-pic"},[_c('span',[_vm._t("why-pic")],2)]),_vm._v(" "),_c('div',{staticClass:"why-title"},[_vm._t("why-title")],2),_vm._v(" "),_c('div',{staticClass:"why-content"},[_vm._t("why-content")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0dc27c2a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/plugins/WhyModule.vue
// module id = null
// module chunks = 